import PropTypes from 'prop-types';
import {
  ICON_LOGO_FACEBOOK,
  ICON_LOGO_YOUTUBE,
  ICON_LOGO_INSTAGRAM,
} from '@bwoty-web/ui-kit/icons';
import { Icon } from '@bwoty-web/ui-kit';
import './socialMediaLinks.scss';

const SocialMediaLinks = ({ links }) => {
  SocialMediaLinks.propTypes = {
    links: PropTypes.string.isRequired,
  };

  let facebookLink;
  let youtubeLink;
  let instagramLink;

  links.forEach((link) => {
    if (!link || !link.href) {
      return; // Go to next iteration
    }

    if (link.href.indexOf('facebook') >= 0) {
      facebookLink = link.href;
    }
    if (link.href.indexOf('youtube') >= 0) {
      youtubeLink = link.href;
    }
    if (link.href.indexOf('instagram') >= 0) {
      instagramLink = link.href;
    }
  });

  return (
    <div className="footer-social-media-container">
      {facebookLink && (
        <a
          className="footer-social-media__link footer-social-media__link--facebook"
          href={facebookLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="visually-hidden">Facebook</span>
          <Icon path={ICON_LOGO_FACEBOOK} size="s" />
        </a>
      )}
      {youtubeLink && (
        <a
          className="footer-social-media__link footer-social-media__link--youtube"
          href={youtubeLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="visually-hidden">YouTube</span>
          <Icon path={ICON_LOGO_YOUTUBE} size="s" />
        </a>
      )}
      {instagramLink && (
        <a
          className="footer-social-media__link footer-social-media__link--instagram"
          href={instagramLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="visually-hidden">Instagram</span>
          <Icon path={ICON_LOGO_INSTAGRAM} size="s" />
        </a>
      )}
    </div>
  );
};

export default SocialMediaLinks;
